import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Button, type ButtonProps } from 'src/component/ds/ui/button';

export interface PillProps extends Omit<ButtonProps, 'children' | 'value'> {
  label: string;
  value: React.ReactNode;
  testId?: string;
}


/* forwardRef so the pill can be an `asChild` trigger (e.g. a tooltip's), which
 * needs the underlying button to position against and attach handlers to. */
export const Pill = React.forwardRef<HTMLButtonElement, PillProps>(
  ({ label, value, testId, variant = 'secondary', size = 'xs', ...props }, ref) => {
    return (
      <Button ref={ref} variant={variant} size={size} data-testid={testId} {...props}>
        <span>
          {label}: <span className='ds-font-bold'>{value}</span>
        </span>
        <ChevronRightIcon fontSize='inherit' aria-hidden='true' />
      </Button>
    );
  }
);
Pill.displayName = 'Pill';
